import { MRT_ColumnDef } from 'material-react-table';
import { useMemo, useState } from 'react';

import {
  SampleTable,
  SearchComponente,
  SingleButton,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { IUbicacionProducto } from '@/shared/interfaces/erp/inventario';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';
import { useUiStore } from '@/store/ui';

export type EquiposDisponiblesOTTecModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const EquiposDisponiblesOTTecModal: React.FC<
  EquiposDisponiblesOTTecModalProps
> = ({ open, setOpen }) => {
  /////* global state
  // equipos disponibles
  const equiposDisponiblesFlota: IUbicacionProducto[] =
    useMaterialesUtilizadosStore(s => s.equiposDisponibles);
  const addSelectedItem = useMaterialesUtilizadosStore(
    s => s.addSelectedItemCustomKey
  );

  const setAlert = useUiStore(s => s.setAlert);

  ///* columns
  const columsnEquiposAsignadosFlota = useMemo<
  MRT_ColumnDef<IUbicacionProducto>[]
  >(
    () => [
      {
        accessorKey: 'actions',
        header: 'Acciones',
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                newCustomButton
                label="AGREGAR"
                variant="text"
                color="success"
                showIcon={false}
                onClick={() => {
                  const itemSeries = row.original?.series || [];
    
                  if (+(itemSeries.length || 0) <= 0) {
                    setAlert(
                      true,
                      'Equipo no contiene series',
                      AlertSeverityEnum.info
                    );
                  }
    
                  addSelectedItem(
                    {
                      ...row.original,
                      cantidadUtilizada: 1,
                      // series
                      selectedSeries: [],
                      contieneSeries: +(itemSeries?.length || 0) > 0,
    
                      id: row.original?.producto_data?.id_producto,
                    },
                    MaterialesKey.equipos_utilizados,
                    'id',
                    false,
                    false
                  );
                }}
              />
            </>
          );
        },
      },
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.producto_data?.codigo || 'N/A',
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
      },

      {
        accessorKey: 'stock_actual',
        header: 'Stock Actual',
        // stock_actual = cantidad transferida
        Cell: ({ row }) => row.original?.stock ?? 'N/A',
      },

    ],
    [addSelectedItem]
  );

  /////* filter ------------
  ///* local state
  const [seachTerm, setSearchTerm] = useState<string>('');
  const filteredMaterialesDisponibles = equiposDisponiblesFlota.filter(item =>
    item?.producto_data?.codigo?.toLowerCase().includes(seachTerm.toLowerCase())
  );


  return (
    <ScrollableDialogProps
      open={open}
      title="Agregar Equipo"
      width="60%"
      contentNode={
        <>
          {/* ======= Search ======= */}
          <SearchComponente
            value={seachTerm}
            onChange={setSearchTerm}
            text="equipos por código"
            sxCard={{
              mb: 3,
            }}
          />

          {/* ======= TABLE ======= */}
          <SampleTable<IUbicacionProducto>
            data={filteredMaterialesDisponibles}
            columns={columsnEquiposAsignadosFlota}
            enablePagination
          />
        </>
      }
      onClose={() => {
        setOpen(false);
        setSearchTerm('');
      }}
      cancelTextBtn="Cerrar"
    />
  );
};

export default EquiposDisponiblesOTTecModal;
